import { createApp } from 'vue';
import { useI18n } from 'vue-i18n';
import ZoomPhoneConfirmDialog from '@/components/organisms/va-app/zoom-phone-widget/ZoomPhoneConfirmDialog.vue';
import { useConfirmWithContent } from '@/composable/message-dialog';
import { i18n } from '@/i18n';

interface ShowConfirmDialogParams {
  clientName: string;
  startedAt: string;
  endedAt?: string;
  phoneNumber: string;
}

/**
 * Zoom Phone確認ダイアログを表示するためのcomposable
 */
export const useZoomPhoneConfirmDialog = () => {
  const { t } = useI18n();
  const { confirmWithContent } = useConfirmWithContent();

  /**
   * 確認ダイアログを表示
   * @returns true: OK clicked, false: Cancel clicked
   */
  const showConfirmDialog = async (params: ShowConfirmDialogParams): Promise<boolean> => {
    const { clientName, startedAt, endedAt, phoneNumber } = params;

    const container = document.createElement('div');
    const app = createApp(ZoomPhoneConfirmDialog, {
      startedAt,
      endedAt,
      phoneNumber,
    });

    app.use(i18n);
    app.mount(container);

    try {
      return await confirmWithContent({
        title: t('vaApp.zoomPhone.confirmDialog.title', { clientName }),
        content: container,
        closeOnClickOutside: false,
      });
    } finally {
      app.unmount();
    }
  };

  return {
    showConfirmDialog,
  };
};
